module.exports = __webpack_public_path__ + "img/bvhABlQN.1c12d4b6.svg";